import { convertToLocalTimeUnix } from '@/composable/useFormatDateAndHours.ts'
import { useReportStore } from '@/store/report'
import {
  buildDoorOpenStateTimelineChartOptions,
  buildDoorOpenStateTimelineSeries,
  countDoorOpenTimelineRows,
  resolveDoorOpenTimelineChartHeight,
  type DoorOpenTimelinePoint,
} from '@/utils/components/door-open-chart'
import { storeToRefs } from 'pinia'
import { computed, ref, watch } from 'vue'

export function useCompareDoorOpenChart() {
  const reportStore = useReportStore()
  const { compareDoorOpenReadings, comparePeriod } = storeToRefs(reportStore)

  const series = ref<{ name: string; data: DoorOpenTimelinePoint[] }[]>([])
  const rowCount = ref(0)

  const chartHeight = computed(() => resolveDoorOpenTimelineChartHeight(rowCount.value))

  const chartOptions = computed(() => {
    const [startDate, endDate] = comparePeriod.value || []
    const min = startDate ? convertToLocalTimeUnix(startDate) : undefined
    const max = endDate ? convertToLocalTimeUnix(endDate) : undefined

    return buildDoorOpenStateTimelineChartOptions({
      id: 'door-open-compare-chart',
      min,
      max,
      height: chartHeight.value,
      rowCount: rowCount.value,
    })
  })

  watch(
    [compareDoorOpenReadings, comparePeriod],
    ([newReadings]) => {
      const sensors = newReadings || []
      const [startDate, endDate] = comparePeriod.value || []
      const rangeStart = startDate ? convertToLocalTimeUnix(startDate) : undefined
      const rangeEnd = endDate ? convertToLocalTimeUnix(endDate) : undefined

      rowCount.value = countDoorOpenTimelineRows(sensors)
      series.value = buildDoorOpenStateTimelineSeries(sensors, convertToLocalTimeUnix, rangeStart, rangeEnd)
    },
    { immediate: true, deep: true },
  )

  return { chartOptions, series, chartHeight }
}
